export interface TosSection { title: string; items: string[] }

export const STUDIO_TOS: { version: string; en: TosSection[]; "pt-BR": TosSection[] } = {
  version: "2026-09-26",
  en: [
    { title: "General Terms", items: [
      "By ordering you agree to our T.O.S",
      "Artist retains ownership for promotional display",
      "Credit the artist and store when posting",
      "No AI or NFT affiliation with our art",
      "No editing or altering the received art",
      "No profits without commercial rights",
    ] },
    { title: "Payment", items: [
      "Payment upfront via PayPal invoice",
      "No refund after work has started",
      "No chargebacks under any circumstances",
      "We issue refunds if we can't complete",
      "Ask for price quote before committing",
      "Tips appreciated but not required!",
    ] },
    { title: "Process", items: [
      "Max 2 weeks for final result",
      "Sketch sent for review before coloring",
      "Free changes during sketch phase",
      "Waitlist available when slots are full",
      "Rush fee available for commercial projects",
      "You'll be notified of queue position",
    ] },
    { title: "Commercial Use", items: [
      "+50-100% of original commission cost",
      "Includes: streaming, merch, video games",
      "Includes: VTubing, monetized content",
      "Must credit artist in visible location",
      "Only applies to specified actions",
      "Outlined clearly in invoice",
    ] },
  ],
  "pt-BR": [
    { title: "Termos gerais", items: [
      "Ao fazer um pedido, você concorda com nossos Termos",
      "O artista mantém o direito de exibir a arte para divulgação",
      "Dê crédito ao artista e à loja ao postar",
      "Nenhuma afiliação com IA ou NFT em nossas artes",
      "Não edite nem altere a arte recebida",
      "Sem lucro sem direitos comerciais",
    ] },
    { title: "Pagamento", items: [
      "Pagamento adiantado via fatura do PayPal",
      "Sem reembolso após o início do trabalho",
      "Sem chargebacks em nenhuma circunstância",
      "Reembolsamos se não pudermos concluir",
      "Peça um orçamento antes de fechar",
      "Gorjetas são bem-vindas, mas não obrigatórias!",
    ] },
    { title: "Processo", items: [
      "Prazo máximo de 2 semanas para o resultado final",
      "Esboço enviado para revisão antes da cor",
      "Alterações gratuitas na fase de esboço",
      "Lista de espera quando as vagas estiverem cheias",
      "Taxa de urgência disponível para projetos comerciais",
      "Você será avisado da sua posição na fila",
    ] },
    { title: "Uso comercial", items: [
      "+50-100% do valor original da comissão",
      "Inclui: streaming, produtos, jogos",
      "Inclui: VTubing, conteúdo monetizado",
      "Crédito ao artista em local visível",
      "Vale apenas para os usos especificados",
      "Descrito claramente na fatura",
    ] },
  ],
};

export function studioTosCanonicalText(): string {
  return STUDIO_TOS.en.map((s) => `# ${s.title}\n${s.items.map((i) => `- ${i}`).join("\n")}\n`).join("\n");
}

export async function sha256Hex(text: string): Promise<string> {
  const bytes = new TextEncoder().encode(text);
  const digest = await globalThis.crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, "0")).join("");
}

export function hashStudioTos(): Promise<string> {
  return sha256Hex(studioTosCanonicalText());
}

export async function hashArtistTos(markdown: string | null | undefined): Promise<string | null> {
  const t = (markdown ?? "").trim();
  return t ? sha256Hex(t) : null;
}
